import React from 'react';
import Markup from "interweave";

const PublicationItem = ({item}) => (
  <article className="publication--snippet padding__16 margin__bottom background__mist">
    <div className="flex__lg clearfix">
      <div className="col-8">
        <h2 className="article--snippet--title blue heading heading__small">
          {item.title}
        </h2>
        <p className="article--snippet--date navy text__small">{`Published ${item.date}`}</p>
        <div className="article--snippet--content navy"></div>
      </div>
      <div className="col-4">
        <a className="button__block button__submit" href={item.file} download="">
          Download pdf <br />({item.file_size})
        </a>
        <a className="button__block button__submit" href={item.agenda} download="">
          Download Agenda <br />({item.file_size})
        </a>
        <a className="button__block button__submit" href={item.minutes} download="">
          Download Minutes <br />({item.file_size})
        </a>
      </div>
    </div>
  </article>
);

export default PublicationItem;
